<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-20 13:37:51
 * @LastEditTime: 2020-09-27 09:57:52
 * @Description: 
--> 
<template>
  <Drawer
    width="400"
    :title="`${openedSac ? '编辑' : '新增'}SAC`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="所属公司" prop="sacCompany">
          <Select v-model="formItem.sacCompany">
            <Option
              v-for="option in sacCompanyList"
              :value="option._id"
              :key="option._id"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "EditSACDrawer",
  data() {
    return {
      drawerOpened: false,
      openedSac: null,
      formItem: {
        name: null,
        sacCompany: null,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "blur" }],
        sacCompany: [
          {
            required: true,
            message: "请选择所属公司",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      sacCompanyList: (state) => state.sacCompany.sacCompanys,
    }),
  },
  methods: {
    ...mapActions({
      createSac: "sac/createSacAction",
      updateSac: "sac/updateSacAction",
    }),
    openDrawer(sac) {
      this.$refs["formItem"].resetFields();
      this.openedSac = sac;
      if (sac) {
        this.formItem.name = this.openedSac.name;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSac) {
              await this.updateSac({
                id: this.openedSac._id,
                data: this.formItem,
              });
            } else {
              await this.createSac(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
